var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1654.7 744",
    style: {
      enableBackground: "new 0 0 1654.7 744"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000150794719621067384590000009110668131586916512_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000052800297393154257340000012367071632263946113_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000057147429407381342160000017333166103811702932_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036247425356685047090000005582265831351433381_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000005268025281760607050000017422658255318128297_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000160174530812826177070000009720025694891220902_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000146469437491555214990000001938363618964915638_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000165229084385527949940000006924452901006797699_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000034078601074964436600000016485154393058265999_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000074406707946975493620000004651189936353340324_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000013174809094638920740000013574526621156323766_);}\n\t.st11{fill:#2E2D25;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M217,125.9h310c50.3,0,91.2,40.8,91.2,91.2V527c0,50.3-40.8,91.2-91.2,91.2H217 c-50.3,0-91.2-40.8-91.2-91.2V217C125.9,166.7,166.7,125.9,217,125.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170272700552397659090000000148185488208242357_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170272700552397659090000000148185488208242357_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146481886249700827640000018190082705211544746_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.4164,
    y1: -424.8669,
    x2: 466.3899,
    y2: -324.3088,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3BDB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDCD7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000146481886249700827640000018190082705211544746_)"
    },
    d: " M302.7,210.5c3.6-18.8,12.2-36,24.9-50.3c-68.8,7.3-90.9,76.4-90.9,76.4H301V229C301,222.9,301.6,216.6,302.7,210.5z M301,301.1 v142h-64.4V301.2c0.1,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1H301V301.1z M416.5,583.8c-3.7,4.1-7.5,7.8-11.6,11.2 s-8.6,6.6-13.4,9.3c-31.9,18.5-71.2,18.5-103.1,0s-51.6-52.5-51.6-89.3v-11c8.4,2.2,17.1,3.3,25.9,3.3h41.6 c6.8,26.4,24,49.4,48.2,63.4C372.2,582.1,394.7,586.4,416.5,583.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028298260636041566140000002441732236877975707_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.0884,
    y1: -464.3676,
    x2: 505.4529,
    y2: 224.873,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0100287,
    style: {
      stopColor: "#E6E4DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    style: {
      stopColor: "#807F7C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000028298260636041566140000002441732236877975707_)"
    },
    d: " M302.7,210.5c3.6-18.8,12.2-36,24.9-50.3c-68.8,7.3-90.9,76.4-90.9,76.4H301V229C301,222.9,301.6,216.6,302.7,210.5z M301,301.1 v142h-64.4V301.2c0.1,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1H301V301.1z M416.5,583.8c-3.7,4.1-7.5,7.8-11.6,11.2 s-8.6,6.6-13.4,9.3c-31.9,18.5-71.2,18.5-103.1,0s-51.6-52.5-51.6-89.3v-11c8.4,2.2,17.1,3.3,25.9,3.3h41.6 c6.8,26.4,24,49.4,48.2,63.4C372.2,582.1,394.7,586.4,416.5,583.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122703014883488406440000016360388219510391997_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.2298,
    y1: -51.8511,
    x2: 571.2591,
    y2: -49.9111,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B7C25F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3BDB9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000122703014883488406440000016360388219510391997_)"
    },
    d: " M507.3,229v11c-8.4-2.2-17.1-3.3-25.9-3.3h-41.6c-6.8-26.4-24-49.4-48.2-63.4c-19.7-11.4-42.2-15.6-64-13c0,0,0.1,0,0.1-0.1 c3.6-4,7.4-7.7,11.5-11.1c4.1-3.4,8.6-6.6,13.4-9.3c31.9-18.5,71.2-18.5,103.1,0C487.6,158.1,507.3,192.2,507.3,229z  M507.3,301.1V443c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.1h-63.4v-142h64.2V301.1z M507.3,507.3c0,0-22.2,69.2-90.9,76.6 l0.1-0.1c0.5-0.5,1-1.1,1.5-1.7c0.3-0.3,0.5-0.7,0.8-1l1.6-2.1c1.6-2.1,3.2-4.2,4.7-6.4c7.9-11.6,13.4-24.9,16-39 c1.1-6,1.6-12.2,1.6-18.5v-7.7L507.3,507.3L507.3,507.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075140789399985160720000004311162564569206195_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.4269,
    y1: -430.0884,
    x2: 636.8087,
    y2: -47.0342,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608807,
    style: {
      stopColor: "#807F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CECDCD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000075140789399985160720000004311162564569206195_)"
    },
    d: " M507.3,229v11c-8.4-2.2-17.1-3.3-25.9-3.3h-41.6c-6.8-26.4-24-49.4-48.2-63.4c-19.7-11.4-42.2-15.6-64-13c0,0,0.1,0,0.1-0.1 c3.6-4,7.4-7.7,11.5-11.1c4.1-3.4,8.6-6.6,13.4-9.3c31.9-18.5,71.2-18.5,103.1,0C487.6,158.1,507.3,192.2,507.3,229z  M507.3,301.1V443c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.1h-63.4v-142h64.2V301.1z M507.3,507.3c0,0-22.2,69.2-90.9,76.6 l0.1-0.1c0.5-0.5,1-1.1,1.5-1.7c0.3-0.3,0.5-0.7,0.8-1l1.6-2.1c1.6-2.1,3.2-4.2,4.7-6.4c7.9-11.6,13.4-24.9,16-39 c1.1-6,1.6-12.2,1.6-18.5v-7.7L507.3,507.3L507.3,507.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107557385016705575800000015191169796185208461_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.9703,
    y1: -162.2402,
    x2: 718.4745,
    y2: -339.0689,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608807,
    style: {
      stopColor: "#BCBAB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4909,
    style: {
      stopColor: "#E6E4DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#807F7C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000107557385016705575800000015191169796185208461_)"
    },
    d: " M229,236.7h7.7v64.1v0.1c-31.8,4.5-48.6,25.7-63.4,51.5c-11.4,19.7-15.6,42.2-13,64c-4-3.6-7.8-7.4-11.2-11.6 c-3.4-4.1-6.6-8.6-9.3-13.4c-18.5-31.9-18.5-71.2,0-103.1C158,256.4,192.1,236.7,229,236.7z M507.3,240.1 c26.4,6.8,49.4,24,63.4,48.2c7,12.2,11.4,25.6,13,39.3c-18.6-16.8-43-26.6-68.8-26.6H301v-64.2h180.4 C490.2,236.8,499,237.9,507.3,240.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151508223758033788630000007280690006468545678_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.9291,
    y1: -167.3932,
    x2: 295.7597,
    y2: -99.6472,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#807F7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6009,
    style: {
      stopColor: "#E6E4DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#807F7C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000151508223758033788630000007280690006468545678_)"
    },
    d: " M595,339.1c3.4,4.1,6.6,8.6,9.3,13.4c18.5,31.9,18.5,71.2,0,103.1c-18.4,31.9-52.5,51.6-89.3,51.6h-7.7V443 c31.8-4.5,48.6-25.9,63.4-51.5c11.4-19.7,15.6-42.2,13-64C587.7,331.1,591.5,334.9,595,339.1z M173.2,455.7 c-7.1-12.2-11.4-25.6-13-39.2c18.8,16.7,43,26.4,68.8,26.3h213.9v64.4H262.5c-8.8,0-17.5-1.1-25.9-3.3 C210.2,497.1,187.2,479.9,173.2,455.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118354918779149222090000011856124678990408366_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.4332,
    y1: -430.0649,
    x2: 636.8016,
    y2: -47.0626,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608807,
    style: {
      stopColor: "#68796F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    style: {
      stopColor: "#D8E8B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#68796F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000118354918779149222090000011856124678990408366_)"
    },
    d: " M507.3,229v11c-8.4-2.2-17.1-3.3-25.9-3.3h-41.6c-6.8-26.4-24-49.4-48.2-63.4c-19.7-11.4-42.2-15.6-64-13c0,0,0.1,0,0.1-0.1 c3.6-4,7.4-7.7,11.5-11.1c4.1-3.4,8.6-6.6,13.4-9.3c31.9-18.5,71.2-18.5,103.1,0C487.6,158.1,507.3,192.2,507.3,229z  M507.3,301.1V443c-0.1,0-0.3,0-0.4,0.1l0,0c-0.1,0-0.3,0.1-0.4,0.1h-63.4v-142h64.2V301.1z M507.3,507.3 c0,0-22.2,69.2-90.9,76.6l0.1-0.1c0.5-0.5,1-1.1,1.5-1.7l0,0c0.3-0.3,0.5-0.7,0.8-1l1.6-2.1c1.6-2.1,3.1-4.2,4.7-6.4 c7.9-11.6,13.4-24.9,16-39c1.1-6,1.6-12.2,1.6-18.5v-7.7L507.3,507.3L507.3,507.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130640094661836351370000013400371917110354060_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.032,
    y1: -162.25,
    x2: 718.4673,
    y2: -339.0548,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608807,
    style: {
      stopColor: "#68796F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4909,
    style: {
      stopColor: "#D8E8B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#68796F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000130640094661836351370000013400371917110354060_)"
    },
    d: " M229,236.7h7.7v64.1v0.1c-31.8,4.5-48.6,25.7-63.4,51.5c-11.4,19.7-15.6,42.2-13,64c-4-3.6-7.8-7.4-11.2-11.6 c-3.4-4.1-6.6-8.6-9.3-13.4c-18.5-31.9-18.5-71.2,0-103.1C158.1,256.4,192.2,236.7,229,236.7z M507.3,240.1 c26.4,6.8,49.4,24,63.4,48.2c7,12.2,11.4,25.6,13,39.3c-18.6-16.8-43-26.6-68.7-26.6H301.1v-64.2h180.4 C490.2,236.8,499,237.9,507.3,240.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176032173027696977750000000105610545671013567_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.8832,
    y1: -167.4974,
    x2: 295.8001,
    y2: -99.7609,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68796F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6009,
    style: {
      stopColor: "#D8E8B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#68796F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000176032173027696977750000000105610545671013567_)"
    },
    d: " M594.9,339.1c3.4,4.1,6.6,8.6,9.3,13.4c18.5,31.9,18.5,71.2,0,103.1c-18.3,31.9-52.4,51.6-89.3,51.6h-7.7v-64.4 c31.8-4.5,48.6-25.9,63.4-51.5c11.4-19.7,15.6-42.2,13-64C587.7,331.1,591.5,334.9,594.9,339.1z M173.3,455.7 c-7.1-12.2-11.4-25.6-13-39.2c18.8,16.7,43,26.4,68.7,26.3h213.9v64.4H262.6c-8.8,0-17.5-1.1-25.9-3.3 C210.3,497,187.3,479.9,173.3,455.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103960102972489329550000009689010674045823372_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.074,
    y1: -465.206,
    x2: 489.8066,
    y2: 122.2402,
    gradientTransform: "matrix(1 0 0 1 -149.04 559.9607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0100287,
    style: {
      stopColor: "#F7FBEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#D8E8B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    style: {
      stopColor: "#68796F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000103960102972489329550000009689010674045823372_)"
    },
    d: " M302.7,210.5c3.6-18.8,12.2-36,24.9-50.3c-68.7,7.3-90.9,76.4-90.9,76.4H301V229C301,222.9,301.6,216.6,302.7,210.5z M301,301.1 l3.5,207.5c7.1,25.9,24,48.4,47.9,62.1c19.9,11.4,42.3,15.6,64.1,13c-3.7,4.1-7.5,7.8-11.6,11.2s-8.6,6.6-13.4,9.3 c-31.9,18.5-71.2,18.5-103.1,0s-51.6-52.5-51.6-89.3v-6.2V504V301.2c0.1,0,0.3,0,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1H301V301.1z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M864.9,491.2V526c-11,2.2-18,2.6-27.3,2.6c-37,0-59.4-14.1-59.4-66V337.2h-32.6v-35.6h32.6v-72.2h43.1v72.2 h43.1v35.6h-43.1V464c0,23.8,6.6,29,25.1,29C853.9,493,857.4,492.6,864.9,491.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1048.3,301.6h43.1V526h-43.1v-28.2h-0.9c-11.9,17.2-35.2,34.3-73.9,34.3c-41.4,0-74.8-23.8-74.8-75.2V301.6 h43.1V445c0,30.4,13.2,50.6,45.8,50.6c37,0,60.7-22.4,60.7-56.3L1048.3,301.6L1048.3,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1139.9,526V211.4h43.1V526H1139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1231.4,526V211.4h43.1V526H1231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1528.4,425.2h-172.5c0.9,37.4,22.9,72.2,67.3,72.2c39.6,0,55-25.5,59-40.5h44 c-11.9,43.1-44.9,75.7-103.8,75.7c-71.3,0-110.9-50.6-110.9-119.2c0-70.4,42.2-118.8,110.9-118.8c68.2,0,106.5,44.9,106.5,114.4 C1528.8,415.1,1528.8,421.7,1528.4,425.2z M1483.9,391.4c0-35.2-24.6-61.6-62.9-61.6c-36.1,0-62.5,24.6-65.1,61.6H1483.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4f2d04d2ce35487c1f53b30b87bcbd4.svg";
export { ForwardRef as ReactComponent };